"use strict";
exports.__esModule = true;
exports.CascadingGrid = void 0;
var CascadingGrid_1 = require("./CascadingGrid");
var CascadingGridItem_1 = require("./CascadingGridItem");
var CascadingGrid = Object.assign(CascadingGrid_1.CascadingGrid, {
    Item: CascadingGridItem_1.CascadingGridItem
});
exports.CascadingGrid = CascadingGrid;
//# sourceMappingURL=index.js.map